import React, { createContext } from 'react';

import { useIndex } from '../hooks';
import { NewWillContext } from '../pages/new-will';

export const PetArrangementsContext = createContext(null);

export function PetArrangementsProvider({ children }) {
  const { will } = React.useContext(NewWillContext);
  console.log('loading pet arrangements', will);
  const { data, loading } = useIndex('pet_arrangements', { will_id: will.id }, !will);

  if (loading) {
    return (
      <div>
        loading pet arrangements...
      </div>
    );
  }

  return (
    <PetArrangementsContext.Provider value={{ arrangements: data || [] }}> 
      {children}
    </PetArrangementsContext.Provider>
  );
}